import { useMemo, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { FilterDropdown as PaletteFilterDropdown } from 'palette/candidates/Filters';
import { PaletteConfigProvider } from 'palette/Config';
import { FilterDropdownList } from 'palette/Filters';
import { ListItem } from 'palette/List';
import { FilterTopLabel } from '@common/Filters/components/FilterTopLabel';
import { MwcDescription } from '@common/Filters/components/MwcDescription';
import { MWC_FILTER_TYPES } from '@common/Filters/constants/filterTypes';
import { FilterItem } from '@common/Filters/containers';
import { prepareForDisplay } from '@common/Filters/helpers';
import { filterSelectors } from '@common/Filters/selectors';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { getStoreEnv } from '@helpers/env';

export function FilterDropdown({
    title,
    filterType,
    isTranslatable,
    hasMultipleGroups
}) {
    const translate = useTranslation();
    const config = useConfig();
    const availableFilters = useSelector(filterSelectors.availableFilters);
    const dropdownFilters = useSelector(filterSelectors.dropdownFilters);

    const description = MWC_FILTER_TYPES.includes(filterType) ? <MwcDescription /> : '';

    const filters = useMemo(() => prepareForDisplay({
        filterTypes: filterType.split(' '),
        availableFilters,
        dropdownFilters,
        hasMultipleGroups
    }), [availableFilters, dropdownFilters, filterType, hasMultipleGroups]);

    return (
        <PaletteConfigProvider
            svgPath={config.SVGURL}
            theme={getStoreEnv(config)}
        >
            <PaletteFilterDropdown>
                <FilterTopLabel
                    description={description}
                    filterType={filterType}
                    label={title}
                />
                <FilterDropdownList>
                    {
                        filters.list.map(filterKey => (
                            <Fragment key={filterKey}>
                                {hasMultipleGroups && (
                                    <ListItem
                                        label={translate(filterKey)}
                                        labelType="large-title"
                                    />
                                )}
                                {
                                    filters.items[filterKey].map(filter => (
                                        <FilterItem
                                            key={filter.value}
                                            filterType={filterType}
                                            isTranslate={isTranslatable}
                                            {...filter}
                                        />
                                    ))
                                }
                            </Fragment>
                        ))
                    }
                </FilterDropdownList>
            </PaletteFilterDropdown>
        </PaletteConfigProvider>
    );
}
